import { z } from "zod"

export const organizationDetailsSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be 255 characters or less"),
  legalName: z
    .string()
    .max(255, "Legal name must be 255 characters or less")
    .nullable(),
  industry: z
    .string()
    .max(255, "Industry must be 255 characters or less")
    .nullable(),
  description: z
    .string()
    .max(1000, "Description must be 1000 characters or less")
    .nullable(),
  phoneNumber: z
    .string()
    .max(50, "Phone number must be 50 characters or less")
    .nullable(),
  address: z
    .string()
    .max(255, "Address must be 255 characters or less")
    .nullable(),
  city: z.string().max(255, "City must be 255 characters or less").nullable(),
  state: z.string().max(255, "State must be 255 characters or less").nullable(),
  zipCode: z
    .string()
    .max(20, "Zip code must be 20 characters or less")
    .nullable(),
  country: z
    .string()
    .max(255, "Country must be 255 characters or less")
    .nullable(),
  taxId: z.string().max(50, "Tax ID must be 50 characters or less").nullable(),
})

export type OrganizationDetailsFormData = z.infer<
  typeof organizationDetailsSchema
>
